<template>
  <div id="detail" class="grid-container full container first">
    <div class="grid-container padding-top-1 padding-bottom-3">
      <div class="grid-x">
        <div class="cell">

          <nav aria-label="You are here:" role="navigation">
            <ul class="breadcrumbs">
              <li>
               <router-link :to="{name: 'home'}">
                Home
              </router-link> 
              </li>
              <li>
                 <router-link :to="{
                      name: 'catalog',
                      params: { catalog: category.categoryFk, entity: category },
                    }">
                  {{mainCategory.name}}
              </router-link>
                </li>
              <li class="disabled">{{ category.name }}</li>
              <li>
                <span class="show-for-sr">Current: </span>  {{ model.nameInfo.contentData }}
              </li>
            </ul>
          </nav>

        </div>
      </div>
    </div>
    <div class="grid-container padding-bottom-3">
      
      <div class="grid-x">
        <!--Left part photo-->
        <div class="product-detail-photos large-7 medium-7 cell">
          <div class="grid-x grid-padding-x">
            <!--1 Presentation-->
            <div class="cell shrink small-photo-slider hide-for-small-only">
              <div
                v-for="(item, index) in images"
                :key="index"
                :class="{ 'active-item': selectedProductIndex === index }"
                style="
                      background-position: center;
                      background-size: contain;
                      background-repeat: no-repeat;
                      width:72px; height:72px;
                      margin-bottom:1rem;"
                :style="
                  'background-image:url(' +
                    baseUrl +
                    item.guid.toString() +
                    item.fileExtension +
                    ')'
                "
                class="owl-item"
                @click="selectedProductIndex = index"
              ></div>
            </div>
            <div class="cell shrink small-photo-slider show-for-small-only">
              <div
                v-for="(item, index) in images"
                :key="index"
                :class="{ 'active-item': selectedProductIndex === index }"
                style="
                      background-position: center;
                      background-size: contain;
                      background-repeat: no-repeat;
                      width:72px; height:72px;
                      margin-bottom: 0rem;
                      margin-right: 1rem;
                      "
                :style="
                  'background-image:url(' +
                    baseUrl +
                    item.guid.toString() +
                    item.fileExtension +
                    ')'
                "
                class="owl-item float-left"
                @click="selectedProductIndex = index"
              ></div>
            </div>

            <!--2 Small photos presentation-->
            <div class="cell medium-auto large-auto">
              <div class="grid-x grid-padding-x">
                <div
                  v-if="images.length && selectedProductIndex > -1"
                  class="cell"
                >
                  <div
                    ref="selectedProductIndex"
                    class="container first"
                    style="
                    background-position: center;
                    background-size: contain;
                    background-repeat: no-repeat;
                    
                    margin-bottom:1rem;

                    height: 520px;
                    "
                    :style="
                      'background-image:url(' +
                        baseUrl +
                        images[selectedProductIndex].guid.toString() +
                        images[selectedProductIndex].fileExtension +
                        ')'
                    "
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--Right part content detail-->
        <div class="large-5 medium-5 cell">
          <!--basic info-->
          <div class="grid-x product-info">
            <div class="cell product-line">
              <span class="">
                {{ category.name }}
              </span>
            </div>
            <div class="cell product-title">
              <h4 class="font-bold">
                {{ model.nameInfo.contentData }}
              </h4>
            </div>
            <div class="cell product-price">
              <h4 class="red font-bold" style="color: #f02f2f;">
                {{ (model.marketPrice || 0).toFixed(2) }} USD
              </h4>
              
               <div class="callout primary" style="border: none;font-size:90%;">
                After selecting all you need and summiting your enquiry, 
                ONEBUY sales will verify your order and offer discount accordingly. 
                Enjoy your selection!
              </div>

            </div>

           

          </div>
          <!--color info-->
          <div class="grid-x product-color-info">
            <div class="cell color-line text-uppercase">
              Color&nbsp;<span class="selected">
                {{ model.color }}
              </span>
            </div>
            <div class="cell color-options">
              <ul class="menu">
                <li
                  v-for="(item, index) in [
                    { id: 1, name: 'White', selected: true },
                  ]"
                  :key="index"
                  class="item"
                  :class="{ selected: item.selected }"
                >
                  <div href="#" class="square"></div>
                </li>
              </ul>
            </div>
          </div>

          <!--size info-->
          <div class="grid-x product-size-info">
            <div class="cell size-line text-uppercase" style="color: #494949;">
              Size&nbsp;<span class="selected">
                {{ model.isStandard ? 'Standard': 'Customize' }}
              </span>
            </div>
            <div class="cell size-options">
              <ul class="menu">
                <li
                  v-for="(item, index) in [
                    { id: 1, name: 'Standard', selected: true },
                    { id: 2, name: 'Customize', selected: false },
                  ]"
                  :key="index"
                  class="item text-capitalize"
                  :class="{ selected: item.selected }"
                >
                  <div class="square">
                    <input
                      :id="'product-option-' + item.id"
                      :name="'product-option'"
                      class="ProductRadioButtons-itemRadio"
                      type="radio"
                      v-model="model.isStandard"
                      :value="item.selected"
                    />
                    <label :for="'product-option-' + item.id">
                      {{ item.name }}
                    </label>
                  </div>
                </li>
              </ul>
            </div>
            <div class="cell padding-top-1">
              <transition name="fade">
                <textarea
                  v-show="!model.isStandard"
                  v-model="remarks"
                  placeholder="Please enter custom size details here."
                  class=""
                ></textarea>
              </transition>
            </div>
          </div>

          <!--quantity info-->
          <div class="grid-x product-quantity-info ">
            <div class="cell large-shrink quantity-line text-uppercase" >
              
              <div class="cell text-uppercase" style="color: #494949;margin-bottom: 0.75rem;">
              Quantity
            </div>

              <span class="selected">
                <product-counter
                  v-model="model.count"
                  :min="1"
                  :max="5000"
                />
              </span>
            </div>
            <div class="cell large-shrink quantity-unit text-uppercase" style="padding-left:1rem;">
               
              <div class="cell text-uppercase" style="color: #494949;margin-bottom: 0.75rem;">
              Unit
            </div>
              <span class="">
                <select v-model="model.uomFk" disabled="disabled">
                  <option v-for="(item, index) in uomList" :key="index" :value="item.id">{{item.name}}</option>
                </select>
              </span>
            </div>
            <!-- <div class="cell quantity-options medium-6">
              <input type="number" value="1" min="1" max="50000" v-model="selectionOptions.quantity" class="radius" />
            </div> -->
          </div>

          <!--add button -->
          <div class="grid-x padding-bottom-2">
            <div class="cell text-uppercase">
              <button 
              v-if="isAuthenticated"
                class="button shopping-cart-btn medium expanded radius "
                @click="addToCart(model)"
                :disabled="cartButton.status===1 || cartButton.status===2"
                style="letter-spacing:1px; line-height: 1.5rem;"
                :class="{'hollow': cartButton.status===2}"
                :style="cartButton.status===2 ? 'opacity: 1': ''">
                  <div>
                   
                    <i class="fi-shopping-cart"></i>
                    
                      <span class="cart-item"></span>
                   
                      
                      <span v-show="cartButton.status===1" class="padding-left-1 text-uppercase">
                        Adding...
                      </span>

                      <span v-show="cartButton.status===2" class="padding-left-1 text-uppercase"
                        >Added
                      </span>

                      <span v-show="cartButton.status===0" class="padding-left-1 text-uppercase">
                        Add To List
                      </span>
                   

                   
                  </div>
                  
                
              </button>
              <router-link :to="{name: 'order'}" v-else class="button shopping-cart-btn medium expanded "
              style="letter-spacing:1px; line-height: 1.5rem;"
              >
               <div>
                   
                    <i class="fi-shopping-cart"></i>
                    
                      <span class="cart-item"></span>

                      <span v-show="cartButton.status===0" class="padding-left-1 text-uppercase">
                        Add To List
                      </span>
                   

                   
                  </div>
              </router-link>
            </div>
          </div>

          <!--more product info -->
          <div class="grid-x">
            <div class="cell moreInfo">
              <ul class="accordion" data-accordion data-allow-all-closed="true">
                <li class="accordion-item is-active" data-accordion-item>
                  <!-- Accordion tab title -->
                  <a
                    href="#"
                    class="accordion-title text-uppercase"
                    style="font-weight: 400;"
                    >Description
                  </a>

                  <!-- Accordion tab content: it would start in the open state due to using the `is-active` state class. -->
                  <div class="accordion-content" data-tab-content>
                    <p>
                      <!-- {{ model.descriptionInfo.contentData }} -->
                      {{ model.dataInfo.contentData }}
                    </p>

                    <!-- <ul>
                          <li>
                          </li>
                      </ul> -->
                  </div>
                </li>

                <li class="accordion-item" data-accordion-item>
                  <!-- Accordion tab title -->
                  <a
                    href="#"
                    class="accordion-title text-uppercase"
                    style="font-weight: 400;"
                    >Specification
                  </a>

                  <!-- Accordion tab content: it would start in the open state due to using the `is-active` state class. -->
                  <div class="accordion-content" data-tab-content>
                    <p>
                      {{ model.introduce }}
                    </p>

                    <!-- <ul>
                          <li>
                          </li>
                      </ul> -->
                  </div>
                </li>

                <li class="accordion-item" data-accordion-item>
                  <!-- Accordion tab title -->
                  <a
                    href="#"
                    class="accordion-title text-uppercase"
                    style="font-weight: 400;"
                    >Packing
                  </a>

                  <!-- Accordion tab content: it would start in the open state due to using the `is-active` state class. -->
                  <div class="accordion-content" data-tab-content>
                    <p>
                      {{ model.packing }}
                    </p>

                    <!-- <ul>
                          <li>
                          </li>
                      </ul> -->
                  </div>
                </li>

                <li class="accordion-item" data-accordion-item>
                  <!-- Accordion tab title -->
                  <a
                    href="#"
                    class="accordion-title text-uppercase"
                    style="font-weight: 400;"
                    >Gross Weight
                  </a>

                  <!-- Accordion tab content: it would start in the open state due to using the `is-active` state class. -->
                  <div class="accordion-content" data-tab-content>
                    <p>
                      {{ model.weight }}
                    </p>

                    <!-- <ul>
                          <li>
                          </li>
                      </ul> -->
                  </div>
                </li>

                <li class="accordion-item" data-accordion-item>
                  <!-- Accordion tab title -->
                  <a
                    href="#"
                    class="accordion-title text-uppercase"
                    style="font-weight: 400;"
                    >Delivery Fee
                  </a>

                  <!-- Accordion tab content: it would start in the open state due to using the `is-active` state class. -->
                  <div class="accordion-content" data-tab-content>
                    <p>
                      Write down your delivery address, after you send your enquiry, 
                      ONEBUY staff will contact you for approximate delivery fee
                    </p>

                    <!-- <ul>
                          <li>
                          </li>
                      </ul> -->
                  </div>
                </li>


              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Related products-->
    <div
      id="relatedProducts"
      class="container"
      style="background-color: #f4f4f4;"
    >
      <div class="grid-container">
        <div class="grid-x">
          <div class="cell container">
            <h2>
              Related Products
              <hr
                style="width: 56px;
                  display: inline-block;
    width: 48px;
    margin: 10px 0px 10px 20px;
    border-color: #5f5e5e;
    border-width: 1px;
              "
              />
            </h2>
          </div>
        </div>

        <div class="grid-x small-up-2 medium-up-3 large-up-5 grid-padding-y">

          <div
              class="cell "
              v-for="(item, index) in relatedProductListFiltered"
              :key="index"
              @mouseover="mouseOverIdx = index"
              @mouseleave="mouseOverIdx = -1"
            >
              <div class="grid-x product-container">
                <div class="cell">
                  <router-link
                    :to="{
                      name: 'product-detail',
                      params: {
                        productId: item.id,
                        catalog: 1,
                        entity: item,
                      },
                    }"
                    class="card card-product radius"
                    :class="{ shadow: mouseOverIdx === index }"
                  >
                    <product-card :item="item" />
                  </router-link>
                </div>
              </div>
            </div>



        </div>
      </div>
    </div>


        <!-- LAST BANNER 2 -->
    <div class="grid-container full position-relative categories-section-container" style="background: white;">
      <div
        class="grid-container full categories-section">

      <div class="grid-x medium-up-4 large-up-4 row">
          <router-link v-for="(item, index) in catalogList" :key="index+60"
          class="cell col" style="overflow: hidden;position:relative;"
          :to="{
              name: 'catalog',
              params: { catalog: item.id, entity: item },
            }"
          >
            <div class="photo-container" 
            :style="'background-image:url(' + getUrl(item.imageSrc) + ')'"></div>
            
            <div class="slide">
              <h3 class="text-capitalize">{{item.name}}
              <br />
              <i class="fi-play-circle"></i>  
              </h3>
            </div>
          </router-link>
          
        </div>

      </div>
    </div>


    <!--Space-->
    <!-- <div class="container"></div> -->
  </div>
</template>

<script>
  import userInfoService from "@/app.user/services/main-service.js";


import "owl.carousel";
import catalogDataService from "@/store.catalog/services/main-service.js";
import productDataService from "@/store.product/services/main-service.js";

import uomDataService from "@/app/services/uom-main-service.js";
import shoppingCartDataService from "@/store.order/services/shopping-cart-service.js";

import configService from "@/app/config-service.js";

export default {
//TODO-V -line:19

  name: "productPage",
  props: ["productId"],
  mixins: [require("@/app/mixins/foundation")],
  components: {
    "product-counter": () => import("@/store.product/components/product-counter"),    
    "product-card": () => import("@/store.product/components/product-card")
  },
  data() {
    return {
      userInfo: {},

      model: {
        nameInfo: {},
        descriptionInfo: {},
        dataInfo: {},

        count: 1,
        remarks: null, //Should be parsed when saved
        isStandard: true, //size
        color: 'default', //TODO-VICTOR: field not added in db
        uomFk: 2 //Default UOM Cartoons: //pcs
      },
      remarks : '', //UnParsed


      mainCategory: {},
      category: {},

      images: [],
      selectedProductIndex: 0,

      relatedProductList: [],

      catalogList: [],
      uomList: [],

      //animation
      cartButton: {
        status: 0 //1: adding, 2: added
      },

      mouseOverIdx: -1, //related products effect
    };
  }, 
  metaInfo(){
    return {
      title: this.model.nameInfo.translated,
      titleTemplate: '%s | OneBuy',
      meta: [
              {
              //vmid: 'description',
                  name: 'description',
                  content: this.model.descriptionInfo.translated
              },
              {
                  //vmid: 'description',
                  name: 'og:description',
                  content: this.model.descriptionInfo.translated
              },
              {
                  //vmid: 'description',
                  name: 'keywords',
                  content: this.model.keywords
              }
          ]
    }
  },
  computed: {
    baseUrl() {
      return configService.baseUrl;
    },
    relatedProductListFiltered(){
      return this.relatedProductList.filter(e=>e.id !== this.model.id);
    },
    fullName() {
            return this.userInfo.lastName
                ? this.userInfo.lastName + " " + this.userInfo.firstName
                : null;
            },
    isAuthenticated(){
        //TODO-VICTOR: CHECK For token or key?
        return this.fullName !== null;
    }
  },
  watch: {
    model: function() {
      this.getProductCategory();
    },
    selectedProductIndex: function() {
      $(this.$refs.selectedProductIndex)
        .hide()
        .fadeIn();
    }
  },
  created() {
    this.initMainCatalogs();
    this.userInfo = userInfoService.getCurrentUserInfo();

    if (this.productId) {
      this.init();
      // this.getProductById();
      // this.getAssetsByProductId();

      //TODO: get products by category
      //getProductCategory.then
    }
  },
  methods: {
    async init(){
      const { data } = await uomDataService.get();
      this.uomList = data;

      var promises = [
        this.getProductById(),
        this.getAssetsByProductId()
      ];

      await Promise.all(promises);

      //this.getProductById();
      //this.getAssetsByProductId();
    },
    getUrl(assetName) {
      // require.context();
      //background:url('" + getUrl("home1.jpg") +"')"
      // return "background:url('" + require("@/assets/images/" + assetName) + '"';
      return assetName ? 
      require("@/assets/images/" + assetName): 
      require("@/assets/images/overlay.png");
    },
    async initMainCatalogs() {
      try {
          this.loading = true;
          const {data} = await catalogDataService.getMainCategories();
          this.setList(data);
      } catch (error) {
          this.errored = true;
          console.error(error);
      } finally {
          this.loading = false;
      }
    },
    setList(items){
      items.forEach(e=>{
        switch (e.id){
          case 1: //home
            e.imageSrc = 'home-or-left-ad.png';
            e.imageBigSrc= 'home-homefitness.jpg'
            break;
          case 9: //covid
            e.imageSrc = 'home-or-middle-ad.jpg';
            e.imageBigSrc= 'home-med1.jpg';
            break;
          case 38: //kitchen
            e.imageSrc = 'home-or-right-ad.jpg';
            e.imageBigSrc= 'home-kitch1.jpg';
            break;
        }
      });
      this.catalogList = items;
      
    },
    async getProductById() {
      try {
        this.loading = true;
        const { data } = await productDataService.getById(this.productId);
        this.setProduct(data);
      }catch (error) {
          this.errored = true;
          console.error(error);
          // if (error.response && error.response.status && error.response.status===404){
          //     //this.$router.push({name:'404'});
          //     this.$router.history.updateRoute(this.$router.match('/404/page-not-found/page-not-found'))
          // }
      }finally{
          this.loading = false;
          this.initialized = true;
      }
     },
    setProduct(data){
      if (!data){
        this.$router.push({name:'home'});
        //this.$router.history.updateRoute(this.$router.match('/404/page-not-found/page-not-found'))
      }

      //Set default values
      data.count = 1;

      try{
        this.remarks = JSON.parse(data.remarks);
      }catch{
        this.remarks = '';
      }

      data.isStandard = true; //size
      data.color = 'default';

      //Default Cartoons  
      const defaultUomFk = this.uomList.length ?  this.uomList[1].id : null;
      if (defaultUomFk === null){
        console.info('no uom');
      }
      data.uomFk = defaultUomFk;

      this.model = data;
    },
    async getAssetsByProductId() {
      const { data } = await productDataService.getAssetsByProductId(
        this.productId
      );
      this.images = data;
    },
    async getProductCategory() {
      const { data } = await catalogDataService.getById(this.model.categoryFk);
      this.category = data;

      //GetMainCategory
      this.getCategoriesAndSetModel();

      //Get related products
      this.getProductsByCatalogId(this.category.categoryFk); //Main category
    },
    async getCategoriesAndSetModel(){
      try {
        this.loading = true;
        const {data} = await catalogDataService.getMainCategories();
        this.mainCategory = data.find(e=>e.id===parseInt(this.category.categoryFk));
      }catch (error) {
          this.errored = true;
          console.error(error);
      }finally{
          this.loading = false;
          this.initialized = true;
      }
    },
    async addToCart(item) {
      let scope = this;

      try {
        
        this.cartButton.status = 1; //adding

        item.remarks = JSON.stringify(scope.remarks);
        
        await shoppingCartDataService.add(item, item.id);

        setTimeout(function() {
          
          $('#cart').addClass("shakeBit"); 
          scope.cartButton.status = 2; //added
          $('.shopping-cart-btn div').addClass('shakeBit');

          //item.remarks = JSON.stringify(scope.remarks);
          // shoppingCartDataService.add(item, item.id);

          setTimeout(function() {
            $('#cart').removeClass("shakeBit");
            scope.cartButton.status = 0; //reset
              $('.shopping-cart-btn div').removeClass('shakeBit');

          }, 1500);

        }, 400);
      }catch (error) {
          this.errored = true;
          console.error(error);
      }finally{
          this.loading = false;
          this.initialized = true;
      }
    },
    async getProductsByCatalogId(catalogId) {
      try {
        this.loadingProducts = true;
        const {data} = await productDataService.getProductsByCatalogId(catalogId);

        this.relatedProductList = data;
      }catch (error) {
          this.errored = true;
          console.error(error);
      }finally{
          this.loadingProducts = false;
          this.initialized = true;
      }
    },
  },
};
</script>

<style lang="scss">
.small-photo-slider {
  .owl-item {
    transition: opacity 0.25s ease;

    cursor: pointer;
    padding-bottom: 0;
    opacity: 0.5;
    &.active-item {
      opacity: 1;
    }
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.shakeBit {
  animation: shakeCart 0.4s ease-in-out forwards;
}

@keyframes shakeCart {
  25% {
    transform: translateX(6px);
  }
  50% {
    transform: translateX(-4px);
  }
  75% {
    transform: translateX(2px);
  }
  100% {
    transform: translateX(0);
  }
}

.shopping-cart-btn *{
  transition: opacity .5s ease-in;
}

</style>

<style lang="scss" scoped>
@import "./../../assets/sass/settings/settings";

.product-info {
  border-bottom: 1px solid rgba(35, 35, 35, 0.2);
  //padding: 0px 0px 16px 0px;
  margin-bottom: 1rem;

  .product-line,
  .product-title,
  .product-price {
    padding-bottom: 0.75rem;
  }

  .product-line .content {
    color: #696c6f;
    font-weight: 500;
    margin-bottom: 0;
  }

  .product-title {
    text-transform: capitalize;
    // font-weight: 500;
  }
  .product-line{
    text-transform: capitalize;
  }
  .product-price {
    // font-size: 0.9rem;
    color: #969696;
  }
}

.product-color-info {
  margin-bottom: 0.5rem;

  .color-line {
    // font-size: 0.8125rem;
    line-height: 1rem;
    color: #494949;
    margin-bottom: 0.75rem;
    // .selected {
    //   padding-left: 5px;
    //   // font-weight: 600;
    // }
  }
  .color-options {
    .item {
      width: 2.5rem;
      height: 2.5rem;
      background-color: #ffffff;
      border: 0.0625rem solid #d8d8d8;
      margin-bottom: 1rem;
      margin-right: 1rem;
      &.selected {
        border: 0.125rem solid var(--primary-color);
      }
    }
  }
}

.product-quantity-info {
  margin-bottom: 0.5rem;

  input {
    font-size: 0.8125rem;
  }

  .quantity-line,
  .quantity-unit {
    // font-size: 0.8125rem;
    line-height: 1rem;
    // color: #232323;
    color: #494949;
    margin-bottom: 0.75rem;
    // .selected {
    //   //padding-left: 5px;
    //   font-weight: 600;
    // }
  }

  //quantity select 
  select{
    border: 1px solid #e9ecef;
    // font-size: 0.8125rem;
    // font-weight: 600;
    flex: 1 0;
    line-height: 1.65;
    height: 2.5em;
    margin: 0 auto;
    padding-left: 0.5rem;
    //padding-right: calc(82 / 16 * 1rem);
    text-align: left;
    width: 100%;
    max-width: 100%;
    vertical-align: top;
    -moz-appearance: textfield;
    &:focus{
      outline: 0;
      border: 0.125rem solid var(--primary-color);
    }
  }
}

.product-size-info {
  margin-bottom: 0.5rem;

  textarea {
    font-size: 0.8125rem;
  }

  .size-line {
    // font-size: 0.8125rem;
    line-height: 1rem;
    color: #494949;
    margin-bottom: 0.75rem;
    text-transform: uppercase;
    // .selected {
    //   // padding-left: 5px;
    //   // font-weight: 600;
    //   // text-transform: capitalize;
    // }
    
  }

  .ProductRadioButtons-itemRadio {
    position: absolute !important;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
  }

  input:checked + label {
    border: 2px solid var(--primary-color);
  }

  label {
    margin-left: 0;

    letter-spacing: 0.1em;
    cursor: pointer;

    position: relative;
    padding: 0.375rem;
    min-width: 2rem;
    min-height: 2rem;
    line-height: 1;
    text-align: center;
    background-color: #ffffff;
    color: #5f5e5e;
    border: 1px solid rgba(35, 35, 35, 0.2);
    cursor: pointer;
    // font-size: 12px;
  }
}

.moreInfo {
  .accordion {
    .accordion-title {
      border-left: none;
      border-right: none;
      font-size: 1rem;
      padding-left: 0;
      color: inherit;
    }
    .accordion-title:hover,
    .accordion-title:focus {
      background-color: transparent;
    }

    .accordion-content {
      border-left: none;
      border-right: none;
      padding-left: 0;
    }

    .is-active .accordion-content {
      border-top: none;
    }
  }
}

#relatedProducts {
  .card {
    transition: all ease 0.25s;
  }
}

.ellipsis {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}


</style>